import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { intervalToDuration } from "date-fns";

/** Seconds as m:ss (or h:mm:ss past an hour). */
export const formatElapsed = (totalSeconds) => {
  const { hours = 0, minutes = 0, seconds = 0 } = intervalToDuration({
    start: 0,
    end: Math.max(0, totalSeconds || 0) * 1000,
  });
  const ss = String(seconds).padStart(2, "0");
  return hours ? `${hours}:${String(minutes).padStart(2, "0")}:${ss}` : `${minutes}:${ss}`;
};

/**
 * The running clock under the record button, the same on the desktop and the phone: proof that
 * it is recording while the first words are still being transcribed.
 */
const RecordingClock = ({ seconds = 0, sx }) => (
  <Stack direction="row" spacing={1} alignItems="center" justifyContent="center" sx={sx}>
    <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: "error.main" }} />
    <Typography variant="body2" color="text.secondary" sx={{ fontVariantNumeric: "tabular-nums" }}>
      {formatElapsed(seconds)}
    </Typography>
  </Stack>
);

export default RecordingClock;
